import { render, staticRenderFns } from "./CaseDetailsHeader.vue?vue&type=template&id=d3dac25c&scoped=true&"
import script from "./CaseDetailsHeader.vue?vue&type=script&lang=ts&"
export * from "./CaseDetailsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CaseDetailsHeader.vue?vue&type=style&index=0&id=d3dac25c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3dac25c",
  null
  
)

export default component.exports